module.exports = __webpack_public_path__ + "static/media/users_selected.32055ca3.svg";